import React from 'react';
import {Box, Typography} from '@material-ui/core';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import {Link} from 'react-router-dom';
import './OrderStatsWidget.scss';

/* ---------- props ---------- */
interface Props {
  link: string;
  today: number;
  yesterday: number;
  thisWeek: number;
  lastWeek: number;
  thisMonth: number;
  lastMonth: number;
}

export default function OrderStatsCard({
  link,
  today,
  yesterday,
  thisWeek,
  lastWeek,
  thisMonth,
  lastMonth,
}: Props) {
  return (
    <div className="order-stats-card">
      <div className="stats-grid">
        <Stat
          title="Today"
          value={today}
          prevTitle="Yesterday"
          prevValue={yesterday}
          link={link}
        />
        <Stat
          title="This Week"
          value={thisWeek}
          prevTitle="Last Week"
          prevValue={lastWeek}
          link={link}
        />
        <Stat
          title="This Month"
          value={thisMonth}
          prevTitle="Last Month"
          prevValue={lastMonth}
          link={link}
        />
      </div>
    </div>
  );
}

/* ---------- sub-component ---------- */
interface StatProps {
  title: string;
  value: number;
  prevTitle: string;
  prevValue: number;
  link: string;
}

function Stat({title, value, prevTitle, prevValue, link}: StatProps) {
  const delta = value - prevValue;
  const isSame = delta === 0;
  const isUp = delta > 0;

  return (
    <Link to={link} className="stat-link">
      <Box className="stat-col">
        <Typography className="widget-heading" variant="caption">
          {title.toUpperCase()}
        </Typography>

        <Typography className="widget-value">{value}</Typography>

        <Box className="stat-compare">
          <Typography variant="caption">
            vs {prevValue} {prevTitle}
          </Typography>
          {!isSame &&
            (isUp ? (
              <ArrowUpwardIcon fontSize="small" />
            ) : (
              <ArrowDownwardIcon fontSize="small" />
            ))}
        </Box>
      </Box>
    </Link>
  );
}
